<template>
	<div
		:class="['panel', 'review']"
	>
		<div class="container">
			<blockquote class="blockquote">
				<div class="row">
					<div class="col-12 col-lg-6">
						<div class="page-content">
							<div class="content">
								{{ block.text }}
							</div>
						</div>
					</div>
				</div>
				<br>
				<div class="row">
					<new-person-line
						:id="block.author.id"
						:title="block.author.title"
						class="experts_list"
						v-bind="block.author"
						long
					/>
				</div>
			</blockquote>
		</div>
	</div>
</template>

<script>
import panel from '~/mixins/panel';
import NewPersonLine from '~/components/blocks/people/NewPersonLine.vue';

export default {
	name: 'PanelAuthoredReview',
	components: {
		NewPersonLine,
	},
	mixins: [panel],
	computed: {
	},
	mounted() {
		console.log(this.block.author);
	},
};
</script>

<style lang="scss" scoped>
</style>
